const constants = {
    ASSESSMENT: "assessment",
    WEB: "web",
    USERS: "users"
};
export { constants as SHARE_TYPES };
